import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, Link } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { StyleSheet, css } from 'aphrodite';

import { Controller } from './common/Controller';
import { AppTheme, AppStyles } from './styles/AppTheme';

import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { NoPermission } from './common/components/NoPermission';

import { DashboardAdmin } from './screens/admin/dashboard/DashboardAdmin';
import { DashboardOrg } from './screens/admin/dashboard/DashboardOrg';

import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { UiHelper } from './common/helpers/UiHelper';
import { Home } from './screens/Home';
import { PublicHeader } from './components/PublicHeader'
import { PublicFooter } from './components/PublicFooter'
import { LoginPage } from './screens/LoginPage';

import { AppConfig } from './AppConfig';
import { AppHelper } from './helpers/AppHelper';
import { ApiHelper } from './common/helpers/ApiHelper';

import { StaffActivity } from './common/components/StaffActivity';
import { StaffActivity2 } from './common/components/StaffActivity2';
import { StaffLoad } from './common/components/StaffLoad';
import { UsageWallet } from './common/components/UsageWallet';
import { StaffOfOrg } from './common/components/StaffOfOrg';
import { CatsL1 } from './common/components/catalog/CatsL1';
import { CatsL2 } from './common/components/catalog/CatsL2';
import { CatsL3 } from './common/components/catalog/CatsL3';
import { ProdLists } from './common/components/catalog/ProdLists';
import { ProductsByCat } from './common/components/catalog/ProductsByCat';
import { ProductsByTag } from './common/components/catalog/ProductsByTag';
import { ProductsByList } from './common/components/catalog/ProductsByList';
import { ProductsByBrand } from './common/components/catalog/ProductsByBrand';

import { Products } from './common/components/catalog/Products';
import { Brands } from './common/components/catalog/Brands';
import { Banners } from './common/components/catalog/Banners';
import { Orders } from './common/components/catalog/Orders';
import { Faqs } from './common/components/Faqs';

import { ProductCustom } from './screens/admin/ProductCustom';

import { Orgs } from './screens/admin/Orgs';
import { BlogTags } from './common/components/blog/BlogTags';
import { BlogsByTag } from './common/components/blog/BlogsByTag';
import { BlogLists } from './common/components/blog/BlogLists';
import { BlogsByList } from './common/components/blog/BlogsByList';
import { Blogs } from './common/components/blog/Blogs';
import { Blog } from './common/components/blog/Blog';
import { Testimonials } from './common/components/Testimonials';
import { Benefits } from './common/components/Benefits';
import { Settings } from './common/components/Settings';
import { Settings2 } from './common/components/Settings2';
import { FaqSections } from './common/components/FaqSections';
import { RichContentEditor } from './common/components/RichContentEditor/RichContentEditor';
import { SettingsMaster } from './common/components/SettingsMaster';
import { CbDefs } from './screens/admin/CbDefs';
import { CbDefFields } from './screens/admin/CbDefFields';
import { CbDats } from './screens/admin/CbDats';
import { CbDefsRead } from './screens/admin/CbDefsRead';
import { Pages } from './screens/admin/Pages';
import { Menus } from './screens/admin/Menus';
import { ItemPreview } from './common/components/Preview/ItemPreview';
import { PageCbs } from './screens/admin/PageCbs';
import { CbDefsGlobal } from './screens/admin/CbDefsGlobal';
import { Coupons } from './common/components/Coupons';
import { CbOrgs } from './screens/admin/CbOrgs';
import { CbDats2 } from './screens/admin/CbDats2';
import { SettingsBranding } from './common/components/SettingsBranding';
import { Footernavs } from './screens/admin/Footernavs';
import { MenusL2 } from './screens/admin/MenusL2';
import { Assets } from './screens/admin/Assets';
import { Jobs } from './screens/admin/Jobs';
import { JobsCrm } from './screens/admin/JobsCrm';
import { FooternavsL2 } from './screens/admin/FooternavsL2';
import { CustomRichContentEditor } from './components/RichContentEditor/CustomRichContentEditor';
import { Tester } from './screens/admin/Tester';
import { ZohoInboxes } from './screens/admin/ZohoInboxes';
import { ZohoDomains } from './screens/admin/ZohoDomains';
import { AWSAmplifyHelper } from './common/helpers/AWSAmplifyHelper';
import { MenusL3 } from './screens/admin/MenusL3';
import { Forms } from './screens/admin/Forms';
import { FormFields } from './screens/admin/FormFields';
import { CoTypes } from './screens/admin/co/CoTypes';
import { CoFields } from './screens/admin/co/CoFields';
import { CoItems } from './screens/admin/co/CoItems';
import { PageCbsCoType } from './screens/admin/PageCbsCoType';
import { ContentTypes } from './screens/admin/content/ContentTypes';
import { ContentType } from './screens/admin/content/ContentType';
import { ContentPersonas } from './screens/admin/content/ContentPersonas';
import { ContentBlogs } from './screens/admin/content/ContentBlogs';
import { ContentGenerator } from './screens/admin/content/ContentGenerator';
import { ContentPlanner } from './screens/admin/content/ContentPlanner';
import { ContentCluster } from './screens/admin/content/ContentCluster';
import { CoTypesRead } from './screens/admin/co/CoTypesRead';
import { CoNestedItems } from './screens/admin/co/CoNestedItems';
import { NestedFields } from './screens/admin/co/NestedFields';
import { Carts } from './screens/admin/Carts';
import { EmbedTags } from './screens/admin/cdp/EmbedTags';
import { Ooh } from './screens/admin/cdp/Ooh';
import { Broadcasts } from './screens/admin/cdp/Broadcasts';
import { Transactional } from './screens/admin/cdp/Transactional';
import { Notifications } from './screens/admin/cdp/Notifications';
import { CrmSequences } from './screens/admin/cdp/CrmSequences';
import { CrmSequenceSteps } from './screens/admin/cdp/CrmSequenceSteps';
import { CrmSequenceEnrolments } from './screens/admin/cdp/CrmSequenceEnrolments';
import { CampaignDetail } from './screens/admin/cdp/CampaignDetail';
import { SequenceDetail } from './screens/admin/cdp/SequenceDetail';
import { CampaignResult } from './screens/admin/cdp/CampaignResult';
import { Segments } from './screens/admin/cdp/Segments';
import { Segments2 } from './screens/admin/cdp/Segments2';
import { EmailCbDefsGlobal } from './screens/admin/EmailCbDefsGlobal';
import { EmailCbDefFields } from './screens/admin/EmailCbDefFields';
import { EmailPages } from './screens/admin/EmailPages';
import { EmailPageCbs } from './screens/admin/EmailPageCbs';
import { EmailCbDats } from './screens/admin/EmailCbDats';
import { Journeys } from './screens/admin/cdp/Journeys';
import { JourneyResult } from './screens/admin/cdp/JourneyResult';
import { Popups } from './screens/admin/cdp/Popups';
import { PopupAnalytics } from './screens/admin/cdp/PopupAnalytics';
import { CrmSettings } from './screens/admin/cdp/CrmSettings';
import { CrmInboxes } from './screens/admin/cdp/CrmInboxes';
import { CrmInbox } from './screens/admin/cdp/CrmInbox';
import { InboxHealthHistoryHost } from './screens/admin/cdp/InboxHealthHistoryDialog';
import { CrmEmailTemplates } from './screens/admin/cdp/CrmEmailTemplates';
import { CrmUserSettings } from './screens/admin/cdp/CrmUserSettings';
import { CrmOneview } from './screens/admin/cdp/CrmOneview';
import { CrmContacts } from './screens/admin/cdp/CrmContacts';
import { CrmContacts2 } from './screens/admin/cdp/CrmContacts2';
import { CrmContact } from './screens/admin/cdp/CrmContact';
import { CrmContactsCustomFields } from './screens/admin/cdp/CrmContactsCustomFields';
import { CbdefTags } from './screens/admin/CbdefTags';
import { CdpSettings } from './screens/admin/cdp/CdpSettings';
import { CbDefFieldsCommon } from './screens/admin/CbDefFieldsCommon';
import { ReportsOrg } from './screens/admin/dashboard/ReportsOrg';
import { CampaignReportsOrg } from './screens/admin/dashboard/CampaignReportsOrg';
import { MobileFooter } from './components/MobileFooter';
import { CrmAccounts } from './screens/admin/cdp/CrmAccounts';
import { CrmAccount } from './screens/admin/cdp/CrmAccount';
import { CrmAccountsCustomFields } from './screens/admin/cdp/CrmAccountsCustomFields';
import { OrgTeams } from './common/components/OrgTeams';
import { Teams } from './screens/admin/cdp/Teams';
import { TeamsFields } from './screens/admin/cdp/TeamsFields';
import { UserActivity } from './common/components/UserActivity';
import { UserActivity2 } from './common/components/UserActivity2';
import { UsersOfOrg } from './common/components/UsersOfOrg';
import { Automations } from './screens/admin/cdp/Automations';
import { AutomationDetail } from './screens/admin/cdp/AutomationDetail';
import { AutomationJourneyDetail } from './screens/admin/cdp/AutomationJourneyDetail';
import { Workflows } from './screens/admin/cdp/Workflows';
import { WhatsappTemplates } from './screens/admin/cdp/WhatsappTemplates';
import { WhatsappFlows } from './screens/admin/cdp/WhatsappFlows';
import { WhatsappContent } from './screens/admin/cdp/WhatsappContent';
import { WhatsappContentDetail } from './screens/admin/cdp/WhatsappContentDetail';
import { WhatsappChatbots } from './screens/admin/cdp/WhatsappChatbots';
import { WhatsappChatbotDetail } from './screens/admin/cdp/WhatsappChatbotDetail';
import { WhatsappNumbers } from './screens/admin/cdp/WhatsappNumbers';
import { CrmNumbers } from './screens/admin/cdp/CrmNumbers';
import { WAVendorProjects } from './common/components/WAVendorProjects';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      AppConfig.GFONTNAME
    ].join(',')
  }
});

const PublicRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={Controller.get().getHomeByRole()} />
    }
  }
  return <Route {...props} />
}

const AutomationDetailRoute = (props) => {
  const locationSearch = props.location ? props.location.search : ''
  const search = locationSearch || ''
  const routeParams = props.match ? props.match.params : null
  const orgId = routeParams ? routeParams.orgId : undefined
  const visual = new URLSearchParams(search).has('visual')
    && AppHelper.isSettingEnabled(orgId, 'AUTOMATION_VISUAL_BUILDER')
  if (visual) {
    return <AutomationJourneyDetail {...props} />
  }
  return <AutomationDetail {...props} />
}

const ProtectedRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props.userLoaded) {
      return <Route {...props} />
    }
    if (props.noPermission) {
      return <Redirect
        to={{
          pathname: '/no-permission',
          state: { redirectedfrom: props.path }
        }}
      />
    }
    Controller.get().loginMgr().bootstrap(async (err, data) => {
      if (err) {
        console.error('bootstrap err:', err)
        props.setNoPermission()
        return
      }
      try{
        const CRM_PATHS = ['/crm-contacts', '/crm-accounts', '/jobscrm','/campaigns/sequences', '/teams', '/teams-fields', '/suborgs', '/workflows', '/crm-numbers', '/crmnumbers']
        const VIEWER_PATHS = ['/crm-contacts', '/crm-accounts','/campaigns/ads']
        const VIEWER_ENHANCED_PATHS = [
          '/campaigns/broadcasts',
          '/whatsapp-broadcasts',
          '/campaigns/:id',
          '/whatsapp-templates',
          '/staff',
        ]

        if (props.path.startsWith('/admin/orgs')) {
          // Any path starts with /admin/orgs - users  has to have a role in that Org or a user of PRODUCT
          const orgId = props.computedMatch.params.orgId
          await Controller.get().cdpHelper().loadSettings(orgId)
          if (AppHelper.isViewerEnhanced(orgId)) {
            VIEWER_PATHS.push(...VIEWER_ENHANCED_PATHS)
          }
          const orgBasePath = '/admin/orgs/:orgId'
          console.log('path:', props.path)
          console.log('orgBasePath:', orgBasePath)
          if (props.path === orgBasePath) {
            if (!Controller.get().userMgr().isProductSU() &&
              !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('BLOGGER') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('CRM') &&
            !Controller.get().roleHelper().hasCurrentOrgRole('VIEWER')
            ) {
              props.setNoPermission()
              return
            }
          } else if (props.path.startsWith(orgBasePath + '/blogs')) {
            if (!Controller.get().userMgr().isProductSU() &&
              !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('BLOGGER')
            ) {
              props.setNoPermission()
              return
            }
          } else if (CRM_PATHS.some(p => props.path.startsWith(orgBasePath + p))) {
            if (VIEWER_PATHS.some(p => props.path.startsWith(orgBasePath + p))) {
              if (!Controller.get().userMgr().isProductSU() &&
                !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
                !Controller.get().roleHelper().hasCurrentOrgRole('CRM') &&
                !Controller.get().roleHelper().hasCurrentOrgRole('VIEWER')
              ) {
                props.setNoPermission()
                return
              }
            } else {
              if (!Controller.get().userMgr().isProductSU() &&
              !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('CRM')
              ) {
                props.setNoPermission()
                return
              }
            }
          } else if (
            props.path.startsWith(orgBasePath + '/settings-master')
            || props.path.startsWith(orgBasePath + '/cotypes')
          ) {
            if (!Controller.get().userMgr().isProductSU() // only allow SU for now
            //&& !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER')
            ) {
              props.setNoPermission()
              return
            }
          } else if (props.path === orgBasePath + '/my-activity') {
            if (!Controller.get().userMgr().isProductSU() &&
              !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('BLOGGER') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('CRM') &&
              !Controller.get().roleHelper().hasCurrentOrgRole('VIEWER')
            ) {
              props.setNoPermission()
              return
            }
          } else {
            if (VIEWER_PATHS.some(p => props.path.startsWith(orgBasePath + p))) {
              if (!Controller.get().userMgr().isProductSU() &&
              !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
            !Controller.get().roleHelper().hasCurrentOrgRole('VIEWER')
              ) {
                props.setNoPermission()
                return
              }
            } else {
              if (!Controller.get().userMgr().isProductSU() &&
              !Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER')
              ) {
                props.setNoPermission()
                return
              }
            }
          }
        } else if (
          props.path.startsWith('/admin/zoho-inboxes')
          || props.path.startsWith('/admin/zoho-domains')
        ) {
          if (!Controller.get().userMgr().isProductSU()) {
            props.setNoPermission()
            return
          }
        } else if (props.path.startsWith('/admin')) {
          // Any path starts with Admin - users has to have a role in PRODUCT Org
          if (!Controller.get().userMgr().isInOrg('PRODUCT')) {
            props.setNoPermission()
            return
          }
        }
        props.setUserLoaded && props.setUserLoaded()
      } catch (err) {
        console.error('protected route err:', err)
        props.setNoPermission()
      }
    })
    return UiHelper.loadingView()
  } else {
    return <Redirect
      to={{
        pathname: '/login',
        state: { redirectedfrom: props.path }
      }}
    />
  }
}

function OrgSegments(props) {
  const orgId = props.match.params.orgId
  const Page = (AppHelper.getSetting(orgId, 'EMAIL_BROADCAST_MODE') || 'LEGACY') === 'NEW'
    ? Segments2
    : Segments
  return <Page {...props} />
}

class App extends Component {

  constructor(props) {
    //console.log('App::constructor')
    super(props);
    const systemInfoStr = localStorage.getItem('systemInfo')
    let systemInfo
    if (systemInfoStr) {
      systemInfo = JSON.parse(systemInfoStr)
    }
    this.state = {
      currentUser: Controller.get().loginMgr().getCurrentUser(),
      appVersionCode:  systemInfo ? systemInfo.versionCode : null,
      webappBaseUrl: systemInfo ? systemInfo.weblink : null,
    };
    AWSAmplifyHelper.init(AppConfig.AWS_AMPLIFY_CONFIG)
  }

  isPublic = () => {
    const pName = window.location.pathname
    if (pName.startsWith('/admin')) {
      return false
    }
    return true
  }

  bootstrapCurrentUser = () => {
    return new Promise((resolve, reject) => {
      if (!Controller.get().loginMgr().getCurrentUser()) {
        resolve(null)
        return
      }

      Controller.get().loginMgr().bootstrap((err, data) => {
        if (err) {
          reject(err)
          return
        }
        resolve(data)
      })
    })
  }

  getCrmContactsNotificationRoute = (orgId) => {
    try {
      const customTabsSetting = AppHelper.getCrmContactCustomTabs(orgId)
      const activeTab = customTabsSetting.find(tab => !!tab.active)
      if (!activeTab) {
        return '/admin/orgs/' + orgId + '/crm-contacts?_sortKey=activeIntSentTs'
      }
      return '/admin/orgs/' + orgId + '/crm-contacts?_activeTab=' + encodeURIComponent(activeTab.label)
    } catch (err) {
      console.log('Failed to resolve CRM contact custom tabs', err)
      return '/admin/orgs/' + orgId + '/crm-contacts?_sortKey=activeIntSentTs'
    }
  }

  getCrmContactsAllTabNotificationRoute = (orgId) => {
    try {
      const customTabsSetting = AppHelper.getCrmContactCustomTabs(orgId)
      const allTab = customTabsSetting.find(tab => tab.label === 'All') || customTabsSetting[0]
      if (!allTab) {
        return '/admin/orgs/' + orgId + '/crm-contacts'
      }
      return '/admin/orgs/' + orgId + '/crm-contacts?_activeTab=' + encodeURIComponent(allTab.label)
    } catch (err) {
      console.log('Failed to resolve CRM contact custom tabs', err)
      return '/admin/orgs/' + orgId + '/crm-contacts'
    }
  }

  getNotificationRoute = (notificationData) => {
    const { orgId, messageType } = notificationData
    switch (messageType) {
    case 'STAFF_LEAD_ASSIGNMENT':
      return this.getCrmContactsAllTabNotificationRoute(orgId)
    default:
      return this.getCrmContactsNotificationRoute(orgId)
    }
  }

  handleNotification = async (event) => {
    const notificationData = event.detail

    if (!(notificationData && notificationData.orgId && notificationData.eventType === 'NOTIFICATION_CLICK')) {
      return
    }

    const { orgId, contactSubOrgId } = notificationData
    Controller.get().roleHelper().setCurrentOrgInfo(orgId, contactSubOrgId || orgId)

    try {
      await this.bootstrapCurrentUser()
      await Controller.get().cdpHelper().loadSettings(orgId)
    } catch (err) {
      console.error('Failed to prepare notification routing context', err)
    }

    window.open(this.getNotificationRoute(notificationData), '_self')
  }

  handleAppEvents = (event) => {
    // this is how data looks
    // {
    // "versionCode": 17,
    // "versionName": "1.0.17",
    // "platform": "android", or ios
    // "model": "GM1901",
    // "osVersion": "11",
    // "package": "com.slixta.consolestage", for production app this will be "com.slixta.console"
    // "devicename": "OnePlus 7",
    // "product": "OnePlus7",
    // "manufacturer": "OnePlus",
    // "eventType": "SYSTEM_INFO"
    // }
    if (AppHelper.isNativeMobileApp()) {
      const data = event.detail
      if (data && data.eventType === 'INIT') {
        const uData = {
          type: 'SYSTEM_INFO',
        }
        AppHelper.postMessageToNativeApp(uData)
      } else if (data && data.eventType === 'SYSTEM_INFO') {
        if (this.state.appVersionCode !== data.versionCode || this.state.webappBaseUrl !== data.weblink) {
          // the state is updated only if there is a change on the version or weblink
          // App.js is loaded multiple times, causing state changes/unnecessary reloads
          this.setState({ appVersionCode: data.versionCode })
          this.setState({ webappBaseUrl: data.weblink })
          localStorage.setItem('systemInfo', JSON.stringify(data))
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('appNotification', this.handleNotification)
    window.removeEventListener('appEvent', this.handleAppEvents)
  }

  componentDidMount() {
    window.addEventListener('appNotification', this.handleNotification);
    window.addEventListener('appEvent', this.handleAppEvents);
  }

  render() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            return (
              <div className={css(Styles.page)}>
                {!this.isPublic() && <Header
                  className={css(Styles.header)}
                  currentUser={this.state.currentUser}
                  onDashboardClick={() => this.onDashboardClick()}
                  onLogoutClick={() => this.onLogoutClick()}
                />}
                {this.isPublic() && <PublicHeader
                  className={css(Styles.header)}
                  currentUser={this.state.currentUser}
                  onDashboardClick={() => this.onDashboardClick()}
                  onLogoutClick={() => this.onLogoutClick()} />}

                <div className={css(Styles.content)}>
                  {this.renderRoute(history)}
                </div>
                <InboxHealthHistoryHost />
                {!this.isPublic() && Controller.get().loginMgr().getCurrentUser() &&
                  <MobileFooter appVersionCode={this.state.appVersionCode} webappBaseUrl={this.state.webappBaseUrl}/>
                }
                {this.isPublic() && <PublicFooter />}
              </div>
            )
          }}
          />
        </MuiThemeProvider>
      </Router>
    );
  }

  setUserLoaded = () => {
    this.setState({ userLoaded: true });
  };

  setNoPermission = () => {
    this.setState({ noPermission: true });
  };

  getProtectedRoute(path, component) {
    return (
      <ProtectedRoute
        userLoaded={this.state.userLoaded}
        setUserLoaded={this.setUserLoaded}
        noPermission={this.state.noPermission}
        setNoPermission={this.setNoPermission}
        exact
        path={path}
        component={component}
      />
    );
  }

  renderRoute(history) {
    Controller.get().setNavigator(history);
    return (
      <Switch>
        {/*
        {this.getProtectedRoute('/admin', Products)}
        {this.getProtectedRoute('/admin/users', UsersOfOrg)}
        {this.getProtectedRoute('/admin/faqs', Faqs)}
        {this.getProtectedRoute('/admin/cats', CatsL1)}
        {this.getProtectedRoute('/admin/cats/:catId/products', ProductsByCat)}
        {this.getProtectedRoute('/admin/cats/:idl1', CatsL2)}
        {this.getProtectedRoute('/admin/cats/:idl1/:idl2', CatsL3)}

        {this.getProtectedRoute('/admin/products', Products)}
        {this.getProtectedRoute('/admin/products/:id', ProductCustom)}
        {this.getProtectedRoute('/admin/lists', ProdLists)}
        {this.getProtectedRoute('/admin/lists/:id', ProductsByList)}
        */}

        {this.getProtectedRoute('/admin', Orgs)}
        {/* {this.getProtectedRoute('/admin/org-mgmt', Orgs)} */}
        {this.getProtectedRoute('/admin/tester', Tester)}
        {this.getProtectedRoute('/admin/zoho-inboxes', ZohoInboxes)}
        {this.getProtectedRoute('/admin/zoho-domains', ZohoDomains)}
        {this.getProtectedRoute('/admin/users', UsersOfOrg)}
        {this.getProtectedRoute('/admin/cbdefs', CbDefsGlobal)}
        {this.getProtectedRoute('/admin/cbdefs-tags', CbdefTags)}
        {this.getProtectedRoute('/admin/cbdefs/:id', CbDefFields)}
        {this.getProtectedRoute('/admin/cbdefs/:id/fieldscommon', CbDefFieldsCommon)}

        {this.getProtectedRoute('/admin/emailcbdefs', EmailCbDefsGlobal)}
        {this.getProtectedRoute('/admin/emailcbdefs/:id', EmailCbDefFields)}
        {this.getProtectedRoute('/admin/emailpages', EmailPages)}
        {this.getProtectedRoute('/admin/emailpages/:id/blocks', EmailPageCbs)}
        {this.getProtectedRoute('/admin/emailcbdats/:id', EmailCbDats)}

        {this.getProtectedRoute('/admin/orgs/:orgId', DashboardOrg)}
        {this.getProtectedRoute('/admin/orgs/:orgId/reports', ReportsOrg)}
        {this.getProtectedRoute('/admin/orgs/:orgId/staff-activity', StaffActivity)}
        {this.getProtectedRoute('/admin/orgs/:orgId/staff-activity/:userId', UserActivity)}
        {this.getProtectedRoute('/admin/orgs/:orgId/staff-interactions', StaffActivity2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/staff-interactions/:userId', UserActivity2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/my-activity', UserActivity2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/staff-assignments', StaffLoad)}
        {this.getProtectedRoute('/admin/orgs/:orgId/usage-wallet', UsageWallet)}
        {this.getProtectedRoute('/admin/orgs/:orgId/staff', StaffOfOrg)}
        {this.getProtectedRoute('/admin/orgs/:orgId/users', UsersOfOrg)}
        {this.getProtectedRoute('/admin/orgs/:orgId/suborgs', Teams)}
        {this.getProtectedRoute('/admin/orgs/:orgId/teams', Teams)}
        {this.getProtectedRoute('/admin/orgs/:orgId/teams-fields', TeamsFields)}
        {this.getProtectedRoute('/teams', Teams)}
        {this.getProtectedRoute('/teams-fields', TeamsFields)}
        {this.getProtectedRoute('/admin/orgs/:orgId/suborgs/:subOrgId/users', UsersOfOrg)}
        {this.getProtectedRoute('/admin/orgs/:orgId/carts', Carts)}
        {this.getProtectedRoute('/admin/orgs/:orgId/customers', CrmContacts)} // TODO: Deprecate
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-contacts-legacy', CrmContacts)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-contacts', CrmContacts2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-contacts/:userId', CrmContact)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-contacts-fields', CrmContactsCustomFields)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-accounts', CrmAccounts)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-accounts/:id', CrmAccount)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-accounts-fields', CrmAccountsCustomFields)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-settings', CrmSettings)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-inboxes', CrmInboxes)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-inboxes/:inboxId', CrmInbox)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-email-templates', CrmEmailTemplates)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-user-settings', CrmUserSettings)}
        {this.getProtectedRoute('/admin/orgs/:orgId/oneview', CrmOneview)}
        {this.getProtectedRoute('/admin/orgs/:orgId/automations', Automations)}
        {this.getProtectedRoute('/admin/orgs/:orgId/automations/:id', AutomationDetailRoute)}
        {this.getProtectedRoute('/admin/orgs/:orgId/workflows', Workflows)}
        {this.getProtectedRoute('/workflows', Workflows)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-templates', WhatsappTemplates)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-flows', WhatsappFlows)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-messages', WhatsappContent)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-messages/:id', WhatsappContentDetail)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-chatbots', WhatsappChatbots)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-chatbots/:id', WhatsappChatbotDetail)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-numbers', WhatsappNumbers)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crm-numbers', CrmNumbers)}
        {this.getProtectedRoute('/admin/orgs/:orgId/crmnumbers', CrmNumbers)}
        {this.getProtectedRoute('/crm-numbers', CrmNumbers)}
        {this.getProtectedRoute('/crmnumbers', CrmNumbers)}
        {this.getProtectedRoute('/admin/orgs/:orgId/faqs', Faqs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/faqsections', FaqSections)}

        {this.getProtectedRoute('/admin/orgs/:orgId/coupons', Coupons)}
        {this.getProtectedRoute('/admin/orgs/:orgId/testimonials', Testimonials)}
        {this.getProtectedRoute('/admin/orgs/:orgId/benefits', Benefits)}
        {this.getProtectedRoute('/admin/orgs/:orgId/settings', Settings2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/settings/:categoryKey', Settings2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/site-settings', Settings)}
        {this.getProtectedRoute('/admin/orgs/:orgId/branding', SettingsBranding)}
        {this.getProtectedRoute('/admin/orgs/:orgId/settings-master', SettingsMaster)}
        {this.getProtectedRoute('/admin/orgs/:orgId/wa-vendor-projects', WAVendorProjects)}

        {this.getProtectedRoute('/admin/orgs/:orgId/cotypes', CoTypes)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cotypes/:id/fields', CoFields)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cotypes/:cotypeid/fields/:id/nestedfields', NestedFields)}
        {/* {this.getProtectedRoute('/admin/orgs/:orgId/cotypes/:id/items', CoItems)} */}

        {this.getProtectedRoute('/admin/orgs/:orgId/cos', CoTypesRead)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cos/:id/items', CoItems)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cos/:id/items/:itemId/subitems', CoNestedItems)}

        {this.getProtectedRoute('/admin/orgs/:orgId/jobs', Jobs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/jobscrm', JobsCrm)}
        {this.getProtectedRoute('/admin/orgs/:orgId/assets', Assets)}

        {this.getProtectedRoute('/admin/orgs/:orgId/content/types', ContentTypes)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content/types/:id', ContentType)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content/personas', ContentPersonas)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content/blogs/:topicClusterId', ContentBlogs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content/planner', ContentPlanner)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content/pillars/:pillar', ContentCluster)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content/generator', ContentGenerator)}

        {this.getProtectedRoute('/admin/orgs/:orgId/forms', Forms)}
        {this.getProtectedRoute('/admin/orgs/:orgId/forms/:id/fields', FormFields)}
        {this.getProtectedRoute('/admin/orgs/:orgId/embed-tags', EmbedTags)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/ads', CampaignReportsOrg)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/ooh', Ooh)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/broadcasts', Broadcasts)}
        {this.getProtectedRoute('/admin/orgs/:orgId/whatsapp-broadcasts', Broadcasts)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/transactional', Transactional)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/notifications', Notifications)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/sequences', CrmSequences)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/sequences/:id', SequenceDetail)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/sequences/:id/steps', CrmSequenceSteps)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/sequences/:id/enrolments', CrmSequenceEnrolments)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/:id', CampaignDetail)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/:id/results', CampaignResult)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/popups', Popups)}
        {this.getProtectedRoute('/admin/orgs/:orgId/campaigns/popups/:id/results', PopupAnalytics)}
        {this.getProtectedRoute('/admin/orgs/:orgId/segments', OrgSegments)}
        {this.getProtectedRoute('/admin/orgs/:orgId/segments2', Segments2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/segments-legacy', Segments)}
        {this.getProtectedRoute('/admin/orgs/:orgId/journeys/messaging', Journeys)}
        {this.getProtectedRoute('/admin/orgs/:orgId/journeys/:id/results', JourneyResult)}
        {this.getProtectedRoute('/admin/orgs/:orgId/journeys/popups', Popups)}
        {this.getProtectedRoute('/admin/orgs/:orgId/journeys/popups/:id/results', PopupAnalytics)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cdp/settings', CdpSettings)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cbdefs', CbDefs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cbdefs/:id', CbDefFields)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cbdefs/:id/fieldscommon', CbDefFieldsCommon)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cbdats/:id', CbDats)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cbdats2/:id', CbDats2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/content-blocks', CbDefsRead)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cborgs', CbOrgs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/pages', Pages)}
        {this.getProtectedRoute('/admin/orgs/:orgId/pages/:id/blocks', PageCbs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/pages/:id/cotypeblocks', PageCbsCoType)}
        {this.getProtectedRoute('/admin/orgs/:orgId/menus', Menus)}
        {this.getProtectedRoute('/admin/orgs/:orgId/menus-l2/:id', MenusL2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/menus-l3/:id', MenusL3)}
        {this.getProtectedRoute('/admin/orgs/:orgId/footernavs', Footernavs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/footernavs/:id', FooternavsL2)}

        {this.getProtectedRoute('/admin/orgs/:orgId/emailpages', EmailPages)}
        {this.getProtectedRoute('/admin/orgs/:orgId/emailpages/:id/blocks', EmailPageCbs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/emailcbdats/:id', EmailCbDats)}

        {this.getProtectedRoute('/admin/orgs/:orgId/products', Products)}
        {this.getProtectedRoute('/admin/orgs/:orgId/products/:id', ProductCustom)}

        {this.getProtectedRoute('/admin/orgs/:orgId/cats', CatsL1)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cats/:catId/items', ProductsByCat)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cats/:idl1', CatsL2)}
        {this.getProtectedRoute('/admin/orgs/:orgId/cats/:idl1/:idl2', CatsL3)}

        {this.getProtectedRoute('/admin/orgs/:orgId/lists', ProdLists)}
        {this.getProtectedRoute('/admin/orgs/:orgId/lists/:id', ProductsByList)}

        {this.getProtectedRoute('/admin/orgs/:orgId/brands', Brands)}
        {this.getProtectedRoute('/admin/orgs/:orgId/brands/:id', ProductsByBrand)}

        {this.getProtectedRoute('/admin/orgs/:orgId/banners', Banners)}
        {this.getProtectedRoute('/admin/orgs/:orgId/orders', Orders)}

        {this.getProtectedRoute('/admin/orgs/:orgId/btags', BlogTags)}
        {this.getProtectedRoute('/admin/orgs/:orgId/btags/:id/blogs', BlogsByTag)}
        {this.getProtectedRoute('/admin/orgs/:orgId/blists', BlogLists)}
        {this.getProtectedRoute('/admin/orgs/:orgId/blists/:id/blogs', BlogsByList)}
        {this.getProtectedRoute('/admin/orgs/:orgId/blogs', Blogs)}
        {this.getProtectedRoute('/admin/orgs/:orgId/blogs/:id', Blog)}
        {this.getProtectedRoute('/admin/orgs/:orgId/blogs/content/:id', CustomRichContentEditor)}

        {this.getProtectedRoute('/admin/orgs/:orgId/preview', ItemPreview)}

        <PublicRoute exact path={'/no-permission'} component={NoPermission} />
        <PublicRoute exact path={'/login'} component={LoginPage} />
        {/* <PublicRoute exact path={'/terms'} component={Terms} />
        <PublicRoute exact path={'/privacy'} component={Privacy} /> */}
        <PublicRoute exact path={'/'} component={Home} />
        <PublicRoute component={NotFound} />
      </Switch>
    )
  }

  onLogoutClick() {
    //console.log('onLogoutClick');
    Controller.get().loginMgr().signOut();
    this.setState({
      currentUser: null
    })
  }

  onDashboardClick() {
    this.props.history.push('/admin');
  }
}

const Styles = StyleSheet.create({
  page: {
    display: 'flex',
    position: 'relative',
    backgroundColor: AppTheme.secondaryBg,
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    },
    '@media (max-width: 1024px)': {
      paddingBottom: 90
    }
  },
  header: {
    flex: '0 0 auto'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    overflowX: 'hidden',
    flex: 1
  },
  footer: {
    flex: '0 0 auto'
  },
  drawerFiller: {
    width: AppTheme.drawerWidth,
    '@media (max-width: 767px)': {
      width: 'unset'
    }
  }
})

export default App;
